// extracted by mini-css-extract-plugin
export default {"wrapper":"SubscriptionPlanPaymentSidebar_wrapper__Zuw-e","loader":"SubscriptionPlanPaymentSidebar_loader__kJd3V"};